export default "__VITE_ASSET__mGncVc4l__"